import { SidebarMenu, SidebarMenuButton } from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'
import { Link, useLocation } from 'react-router-dom'

import type { FC } from 'react'

export const SettingsLeftNav: FC = () => {
	const location = useLocation()

	// Define menu items with their URLs
	const menuItems = [
		{
			title: 'General',
			url: '../general',
		},
		{
			title: 'Users',
			url: '../users',
		},
	]

	return (
		<SidebarMenu>
			{menuItems.map((item) => {
				// Use the same logic as nav-section.tsx for consistency
				const isItemActive = location.pathname.endsWith(item.url.split('/').pop() || '')

				return (
					<SidebarMenuButton
						tooltip={item.title}
						asChild
						key={item.title}
						className={cn(isItemActive && 'bg-sidebar-accent text-sidebar-accent-foreground')}
					>
						<Link to={item.url}>
							<span>{item.title}</span>
						</Link>
					</SidebarMenuButton>
				)
			})}
		</SidebarMenu>
	)
}
